import { useEffect } from 'react';

/** Publishes the on-screen keyboard height as --keyboard-inset so the panels shrink into it. */
export function useKeyboardInset(): void {
  useEffect(() => {
    const vv = (window as unknown as { visualViewport?: VisualViewport }).visualViewport;
    // Chrome 58 has no visualViewport - the WebView resizes there, so 0 is already right.
    if (!vv || !vv.addEventListener) return;
    const update = () => {
      const covered = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      document.documentElement.style.setProperty('--keyboard-inset', `${Math.round(covered)}px`);
    };
    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
      document.documentElement.style.removeProperty('--keyboard-inset');
    };
  }, []);
}
